export enum ChatEventType {
  // When sent, this event creates a new message.
  // When received, it means a new message was created.
  //
  // NOTE: The send/receive message flow is *asyncrhonous*
  //    When sending a message, we don't receive a "reply" similar to HTTP mechanisms.
  //    Instead, the server will push a 'new_message' event of its own, with the newly created message.
  //    Clients should rely on received events as the source of truth.
  //
  // Multiple messages with the same ID can be received during the lifetime of the socket.
  //    This can happen when the AI Agent is streaming a response, or when loading the chat history.
  //    Messages with the same ID should only be displayed once.
  NewMessage = 'new_message',

  // Request the server for previous messages in a chat.
  //
  // The server will send a new 'load_chat' event with the chat history
  // In future versions, we'll want to include pagination, but right now it sends everything.
  LoadChat = 'load_chat',

  // When a new chat is created, or when a user gets invited to another chat room, the server sends
  // us this event. We need to send it back so the backend can add the client to the new rooms.
  // Ideally this would be transparent to the user, but due to a technical limitation of the socket.io
  // lib, we need the client to make the request
  RefreshChatRooms = 'refresh_rooms',

  // Should be sent to the server once RefreshChatRooms is received
  JoinChatRooms = 'refresh_rooms',

  // Sent when an error occurs
  Error = 'error',

  // Agent Events
  AgentEvent = 'agent_event'
}
